export interface IUserHeaderDetail {
  businesses?: unknown[];
  wellbeing?: unknown;
  terms_and_pricing?: unknown;
}

export interface IUserApiData {
  email: string;
  password: string;
  first_name: string;
  last_name: string;
  avatar: string;
  provider: string;
  correct_image: string;
  phone_no: string;
  hakunate_id: string;
  is_superuser: boolean;
  is_active: boolean;
  is_admin: boolean;
  is_staff: boolean;
  is_customer: boolean;
  is_owner: boolean;
  is_practitioner: boolean;
  id: number;
}

export class User {
  public id!: number;
  public email!: string;
  public password!: string;
  public first_name!: string;
  public last_name!: string;
  public avatar!: string;
  public provider!: string;
  public correct_image!: string;
  public phone_no!: string;
  public country_code!: string;
  public hakunate_id!: string;
  public age!: number;
  public last_login!: Date;
  public is_superuser!: boolean;
  public is_active!: boolean;
  public is_admin!: boolean;
  public is_staff!: boolean;
  public is_customer!: boolean;
  public is_owner!: boolean;
  public is_practitioner!: boolean;
  public created_at!: Date;
  public updated_at!: Date;
  public allow_sms!: boolean;
  public allow_push!: boolean;
  public allow_email!: boolean;
  public businesses = [];
  public header_detail!: IUserHeaderDetail;
  public gender?: string;
  public is_wellbeing_owner?: boolean;
  public is_wellbeing_employees?: boolean;

  public copy(jsonData: IUserApiData): void {
    this.email = jsonData.email;
    this.password = jsonData.password;
    this.first_name = jsonData.first_name;
    this.last_name = jsonData.last_name;
    this.avatar = jsonData.avatar;
    this.provider = jsonData.provider;
    this.correct_image = jsonData.correct_image;
    this.phone_no = jsonData.phone_no;
    this.hakunate_id = jsonData.hakunate_id;
    //		this.last_login = new Date(jsonData.last_login);
    this.is_superuser = jsonData.is_superuser;
    this.is_active = jsonData.is_active;
    this.is_admin = jsonData.is_admin;
    this.is_staff = jsonData.is_staff;
    this.is_customer = jsonData.is_customer;
    this.is_owner = jsonData.is_owner;
    this.is_practitioner = jsonData.is_practitioner;
    //		this.created_at = new Date(jsonData.created_at);
    //		this.updated_at = new Date(jsonData.updated_at);
    this.id = jsonData.id;
  }
}
